.card {
  padding: var(--sp-6);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}
.cardTitle {
  font-size: var(--fs-xl);
}
.cardText {
  margin: var(--sp-2) 0 0;
}
